var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 21.6C17.3018 21.6 21.5999 17.3019 21.5999 12C21.5999 6.69807 17.3018 2.4 11.9999 2.4C6.69797 2.4 2.3999 6.69807 2.3999 12C2.3999 17.3019 6.69797 21.6 11.9999 21.6ZM10.9995 5.99961C10.9995 5.44733 11.4472 4.99961 11.9995 4.99961C12.5518 4.99961 12.9995 5.44733 12.9995 5.99961V10.9996L15.9995 10.9994C16.5518 10.9994 16.9995 11.4471 16.9995 11.9994C16.9995 12.5517 16.5518 12.9994 15.9996 12.9994L11.9996 12.9996C11.7343 12.9996 11.48 12.8943 11.2924 12.7067C11.1049 12.5192 10.9995 12.2648 10.9995 11.9996V5.99961Z",
    fill: "#3EB0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndClock);
export default __webpack_public_path__ + "static/media/end-clock.848350bb4a632e6e79b973e73be0407e.svg";
export { ForwardRef as ReactComponent };